import _ from 'lodash'
import { observer } from 'mobx-react'
import React, { useState } from 'react'
import Modal from '../../Components/Modal'
import DataStore from '../../State/DataStore'
import { useNavigate } from '@tanstack/react-router'
import { handleEntityDelete } from '../../Utils/deleteEntity'

export default observer(({ role, modalId }) => {
    const navigate = useNavigate()
    return (
        <Modal
            modalId={modalId}
            heading="Delete Staff Role"
            saveButtons={[
                {
                    label: 'Archive Role',
                    onClick: () => {
                        if (!role.createdAt) {
                            handleEntityDelete(role, 'role', navigate)
                        } else {
                            role.update({ isArchived: true })
                            DataStore.saveModel(role)
                            navigate({ to: '/staff-roles/' })
                        }
                    },
                },
                {
                    label: 'Delete Role',
                    onClick: () => handleEntityDelete(role, 'role', navigate),
                },
            ]}
        >
            <p style={{ margin: '1em' }}>
                Are you sure you wish to delete <em>{role.name}</em>?
            </p>
        </Modal>
    )
})
